import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ModalX from '../../../shared/ui/elements/Modal-X';

const RestrictionInfoModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
}) => {
  const { t } = useTranslation('salary-card');

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <ModalX close={() => setOpen(false)} />
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mt={7}>
          <img
            src='/images/digital_account/non_working_info.png'
            alt='non working hour'
            width={64}
            height={64}
          />
          <Typography fontSize={28} lineHeight={1.2} fontWeight={'bold'} align='center' my={3}>
            {t('restriction.title')}
          </Typography>
          <Typography fontSize={16} lineHeight={1.4} align='center'>
            {t('restriction.description')}
          </Typography>

          <Button
            sx={{ width: '100%', mt: 3, height: 56 }}
            onClick={() =>
              window.open('https://www.yelo.az/az/individuals/atms-and-branches/', '_blank')
            }
          >
            {t('restriction.branchList')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RestrictionInfoModal;
